// necessary fields of product grids product-v3
export const productGridsFields =
  'brand,categories,combinations,default_category,' +
  'default_combination,discount_percentage,discount_range,id,images,is_active_in_sociolla,is_buy_one_get_one_free,' +
  'is_exclusive,is_in_stock,is_limited,is_new,is_online,is_out_of_stock_sociolla,is_sale,max_limit_per_order,' +
  'max_price,max_price_after_discount,min_price,min_price_after_discount,my_sociolla_sql_id,name,pack_detail,' +
  'price_after_discount_range,price_range,review_stats,slug,url_sociolla,_id,classification,frame_url';

export const DEFAULT_FIELDS_BRAND = '_id name slug logo featured_text';
